import * as React from 'react';

function NiceLogo(props) {
  return (
    <svg
      id='Group_1542'
      data-name='Group 1542'
      xmlns='http://www.w3.org/2000/svg'
      width={30.661}
      height={27.003}
      viewBox='0 0 30.661 27.003'
      {...props}
    >
      <path
        id='Path_580'
        data-name='Path 580'
        d='M9.983,0c.226.022.452.048.678.066a8.991,8.991,0,0,1,4.878,1.9,9.88,9.88,0,0,1,3.2,4.139,8.706,8.706,0,0,1,.627,2.755c.022.371.035.744.036,1.115,0,2.519.009,5.038-.007,7.557a1.663,1.663,0,0,1-.881,1.6,2.7,2.7,0,0,1-1.519.219,1.994,1.994,0,0,1-.962-.319,1.627,1.627,0,0,1-.678-1.191,5.062,5.062,0,0,1-.037-.688c0-2.554.021-5.109-.012-7.663a5.333,5.333,0,0,0-2.008-4.124,5.369,5.369,0,0,0-2.819-1.248,4.254,4.254,0,0,0-.565-.042q-2.815,0-5.63,0h-.16v.237q0,10.351,0,20.7A2.16,2.16,0,0,1,3.771,26.3a1.656,1.656,0,0,1-1.148.658,3.1,3.1,0,0,1-1.437-.078A1.585,1.585,0,0,1,.034,25.5.5.5,0,0,0,0,25.4V1.632a.327.327,0,0,0,.033-.078A1.591,1.591,0,0,1,1.339.1C1.518.057,1.7.033,1.883,0Z'
        transform='translate(0)'
        fill='#fff'
      />
      <path
        id='Path_582'
        data-name='Path 582'
        d='M67.017,64.891v-.262q0-6.679,0-13.357a3.6,3.6,0,0,1,.085-.752,1.5,1.5,0,0,1,1.131-1.187,2.818,2.818,0,0,1,1.435-.037,1.759,1.759,0,0,1,1.372,1.493,4.039,4.039,0,0,1,.072.791q.006,7.636,0,15.272a3.3,3.3,0,0,1-.119.888A1.579,1.579,0,0,1,69.526,68.9a7.776,7.776,0,0,1-.885.036c-2.445,0-4.89.013-7.335,0a9.167,9.167,0,0,1-5.816-2.011,9.764,9.764,0,0,1-3.317-4.613,9.28,9.28,0,0,1-.466-2.916q-.006-3.893,0-7.787a3.033,3.033,0,0,1,.1-.784,1.569,1.569,0,0,1,1.361-1.173,3.071,3.071,0,0,1,1.488.086,1.569,1.569,0,0,1,1.11,1.334,3.2,3.2,0,0,1,.039.545c0,2.5,0,5,0,7.5a5.6,5.6,0,0,0,4.59,5.694,4.772,4.772,0,0,0,.916.078c1.824.007,3.647,0,5.47,0h.228'
        transform='translate(-44.051 -41.935)'
        fill='#fff'
      />
      <path
        id='Path_586'
        data-name='Path 586'
        d='M141.845,2.561l-.82.819a6.913,6.913,0,0,0-9.709,0l-.814-.815a8.018,8.018,0,0,1,11.343-.005'
        transform='translate(-111.184 -0.182)'
        fill='#fff'
      />
      <path
        id='Path_587'
        data-name='Path 587'
        d='M149.629,17.558l-.82.823a4.553,4.553,0,0,0-6.413.008l-.814-.814a5.677,5.677,0,0,1,8.047-.017'
        transform='translate(-120.624 -13.542)'
        fill='#fff'
      />
      <path
        id='Path_588'
        data-name='Path 588'
        d='M157.56,32.559l-.82.819a2.25,2.25,0,0,0-1.563-.626,2.2,2.2,0,0,0-1.546.623l-.814-.813a3.348,3.348,0,0,1,4.744,0'
        transform='translate(-130.195 -26.901)'
        fill='#fff'
      />
    </svg>
  );
}
export default NiceLogo;
